import "flickity";
import "flickity-imagesloaded";
import "flickity-as-nav-for";
import "flickity-fade";
import "./aos.js";
import "./countup.js";
import "./typed.js";
import "./flickity.js";
